import { render, staticRenderFns } from "./HarvestData.vue?vue&type=template&id=358a3e0c&"
import script from "./HarvestData.vue?vue&type=script&lang=js&"
export * from "./HarvestData.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../home/ubuntu/albert_frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports